module.exports = __webpack_public_path__ + "media/icons/attachment-2174eb25.svg";